import { EnquiryForm } from "./EnquiryForm";
import { FORMS } from "./formConfig";

export default function ArtistForm() {
  return <EnquiryForm config={FORMS.artist} />;
}
